<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Értekezlet</ion-title>
    <ion-buttons slot="end" *ngIf="folyamatban">
      <ion-button (click)="exit()" color="danger" fill="solid" shape="round">
        <ion-icon slot="start" name="exit-outline"></ion-icon>
        Értekezlet elhagyása
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="ertekezlet-tartalom">

  <!--  A FUTÓ ÉRTEKEZLET. Az ablak a teljes felületet kapja: ez a képernyő lényege,
        minden más ilyenkor elrejtőzik. -->
  <div id="ertekezlet" class="ertekezlet-ablak" [class.aktiv]="folyamatban">
    <iframe id="frame" src="" allowfullscreen
            allow="camera; microphone; display-capture; clipboard-read; clipboard-write"></iframe>
  </div>

  <div class="ert-lap" *ngIf="!folyamatban">

    <!--  NINCS BEÁLLÍTVA: ne egy üres ablak fogadja a kollégát, hanem az, hogy mi a teendő. -->
    <div class="ert-uzenet" *ngIf="!beallitva">
      <ion-icon name="videocam-off-outline"></ion-icon>
      <h2>Az értekezlet még nincs beállítva</h2>
      <p>
        Ehhez az iskolához nincs megadva értekezlet-kiszolgáló. Az adminisztrátor az
        <b>Adminisztráció → Törzsadatok → feladatellatas</b> alatt, a <b>cooperante</b> mezőben
        adhatja meg a címet — sablonnal is, például
        <code>https://ertekezlet.iskola.hu/{{ '{szoba}' }}</code>.
      </p>
    </div>

    <ng-container *ngIf="beallitva">
      <div class="ert-fejlec">
        <h1>Online értekezlet</h1>
        <p>Indíts újat, vagy csatlakozz egy meglévőhöz a szobakóddal. Külsős vendéget a megosztott
          linkkel tudsz behívni — nem kell hozzá fiók.</p>
      </div>

      <div class="ert-kartyak">
        <!-- ÚJ ÉRTEKEZLET -->
        <button type="button" class="ert-kartya ert-kartya--fo" (click)="newMeeting()">
          <span class="ert-ikon"><ion-icon name="videocam-outline"></ion-icon></span>
          <span class="ert-szoveg">
            <b>Új értekezlet</b>
            <small>Azonnal indul, a szobakódot utána megoszthatod.</small>
          </span>
          <ion-icon class="ert-nyil" name="chevron-forward-outline"></ion-icon>
        </button>

        <!-- CSATLAKOZÁS -->
        <div class="ert-kartya">
          <span class="ert-ikon ert-ikon--halvany"><ion-icon name="enter-outline"></ion-icon></span>
          <span class="ert-szoveg">
            <b>Csatlakozás</b>
            <small>Írd be a kapott szobakódot (8 karakter) vagy illeszd be a linket.</small>
            <span class="ert-csatlakozas">
              <ion-input [(ngModel)]="szobakod" placeholder="Szobakód vagy link" fill="outline"
                         (keyup.enter)="connectMeeting()" maxlength="120"></ion-input>
              <ion-button (click)="connectMeeting()" [disabled]="!szobakod?.trim()">Belépés</ion-button>
            </span>
          </span>
        </div>
      </div>

      <!-- FELVÉTELEK -->
      <div class="ert-felvetelek" *ngIf="felvetelekLathato">
        <div class="ert-alcim">
          <h2>Felvételek</h2>
          <ion-button fill="clear" size="small" (click)="felvetelekBetoltese()" [disabled]="felvetelekToltes">
            <ion-icon slot="start" name="refresh-outline"></ion-icon>
            Frissítés
          </ion-button>
        </div>

        <p class="ert-ures" *ngIf="!felvetelek.length && !felvetelekToltes">
          Még nincs felvétel ennél az iskolánál<span *ngIf="intezmenyNev"> ({{ intezmenyNev }})</span>.
          Az értekezlet alatt a <b>⋮ → Felvétel</b> menüponttal indítható; a kész felvétel
          néhány másodperccel a vége után jelenik meg itt.
        </p>

        <div class="ert-felvetel" *ngFor="let f of felvetelek">
          <div class="ert-felvetel-fej" (click)="jatszd(f)">
            <span class="ert-ikon ert-ikon--halvany"><ion-icon name="play-circle-outline"></ion-icon></span>
            <span class="ert-szoveg">
              <b>{{ f.szoba }}</b>
              <small>
                {{ (f.kezdete || f.feltoltve) | date:'yyyy. MM. dd. HH:mm' }}
                <span *ngIf="f.hossz_mp"> · {{ hossz(f.hossz_mp) }}</span>
                · {{ meret(f.meret) }}
              </small>
            </span>
            <span class="ert-muveletek">
              <ion-button fill="outline" size="small" (click)="$event.stopPropagation(); jatszd(f)">
                {{ jatszott?.id === f.id ? 'Bezár' : 'Lejátszás' }}
              </ion-button>
              <ion-button fill="clear" size="small" title="Megosztás üzenetben"
                          (click)="$event.stopPropagation(); megosztasUzenetben(f)">
                <ion-icon slot="icon-only" name="paper-plane-outline"></ion-icon>
              </ion-button>
              <ion-button fill="clear" size="small" title="Letöltés"
                          (click)="$event.stopPropagation(); fajlNyit(felvetelCime(f), f?.nev || 'felvetel')">
                <ion-icon slot="icon-only" name="download-outline"></ion-icon>
              </ion-button>
              <ion-button fill="clear" size="small" color="danger" title="Törlés"
                          (click)="$event.stopPropagation(); felvetelTorles(f)">
                <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
              </ion-button>
            </span>
          </div>
          <video *ngIf="jatszott?.id === f.id && lejatszoCim" [src]="lejatszoCim" controls preload="metadata"></video>
        </div>
      </div>
    </ng-container>
  </div>
</ion-content>
